import { Action } from 'redux'
import { ClientConfig } from '../../config/ClientConfig'
import { JackpotsHistory } from '../../data/JsngTypes'
import { PokerMap } from '../../data/Map'
import { ReduxAction } from '../ReduxUtils'
import {
	JackpotHistoryPayload,
	RECEIVE_JACKPOT_HISTORY,
	REQUEST_JACKPOT_ERROR,
	REQUEST_JACKPOT_HISTORY,
} from './JackpotPrizeHistoryAction'

export interface JackpotPrizeHistoryState {
    jackpotsHistoryMap: PokerMap<JackpotsHistory[]>;
    loading: boolean;
}

const initialState: JackpotPrizeHistoryState = {
	jackpotsHistoryMap: new PokerMap<JackpotsHistory[]>(),
	loading: true,
}

export const jackpotPrizeHistoryReducer
    = (state: JackpotPrizeHistoryState = initialState, reduxAction: Action): JackpotPrizeHistoryState => {
    	const action: ReduxAction<any> = reduxAction as ReduxAction<any>
    	switch (action.type) {
    	case REQUEST_JACKPOT_HISTORY:
    		return { ...state, loading: true }
    	case RECEIVE_JACKPOT_HISTORY:
    		const payloadNew = action.payload as JackpotHistoryPayload
    		sanitiseHistory(payloadNew.jackpotHistory)
    		state.jackpotsHistoryMap.put(payloadNew.currencyCode, payloadNew.jackpotHistory)
    		return { ...state, loading: false }
    	case REQUEST_JACKPOT_ERROR:
    		return { ...state, loading: false }
    	default:
    		return state
    	}
    }

export function sanitiseHistory(jackpotHistory: JackpotsHistory[]): void {
	const blacklist = ClientConfig.JSNG_BLOCKLIST
	jackpotHistory.forEach(history => {
		if (history.jackpotWinner) {
			history.jackpotWinner.screenName =
                blacklist.includes(history.jackpotWinner.screenName) ? '[Player]' : history.jackpotWinner.screenName
		}
		history.recentWinners.forEach(winner => {
			winner.screenName = blacklist.includes(winner.screenName) ? '[Player]' : winner.screenName
		})
	})
}
